import { translation } from 'I18n/i18n'
import ScrollContainer from 'components/scrollContainer/scrollContainer'
import ScrollSection from 'components/scrollSection/scrollSection'
import AnchorButtonContext from 'contexts/anchorButton'
import { useCounterContext } from 'contexts/counter'
import HeadbandContext from 'contexts/headband'
import { useContext, useEffect } from 'react'
import { useSelector } from 'react-redux'
import Produits from './produits/produits'
import AnchorPart from 'components/anchorPart/anchorPart'

export default function NosClientsNosProduits() {
   const { setCounter, counterDefault } = useCounterContext()
   const { setHeadband } = useContext(HeadbandContext)
   const { setAnchorButton } = useContext(AnchorButtonContext)
   useEffect(() => {
      setCounter(counterDefault)
      setHeadband('Nos Clients<br/>Nos Produits')
      setAnchorButton(translation(lang, 'gammeProduits', 'anchorBtns'))
   }, [])
   const lang = useSelector((state: any) => state.languageReducer.language)
   return (
      <ScrollContainer>
         <AnchorPart anchor={{partName: 'NOS CLIENTS (LISTE NON EXHAUSTIVE)', id: 0}}/>
         <ScrollSection zoneName='Nos clients'  />
         <AnchorPart anchor={{"partName": "Nos produits", "id": 1}} />
         <Produits />
      </ScrollContainer>
   )
}
